function validInstant(value) {
    if (!value)
        return null;
    const instant = new Date(value);
    return Number.isFinite(instant.getTime()) ? instant : null;
}
/**
 * The day a medal was earned, for a profile tile. The clock time and any
 * note that it was not recorded stay on the award detail page.
 */
export function profileAwardDate(reached, locale) {
    if (!reached)
        return null;
    const crossed = validInstant(reached.reachedAt);
    if (crossed) {
        return new Intl.DateTimeFormat(locale, {
            dateStyle: "medium",
            timeZone: reached.timezone,
        }).format(crossed);
    }
    // Calendar-only history must not shift a day when viewed in another timezone.
    const day = validInstant(`${reached.reachedOn}T12:00:00Z`);
    if (!day)
        return null;
    return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone: "UTC" }).format(day);
}
export function reachedDateLabel(reached, locale) {
    const date = profileAwardDate(reached, locale);
    if (!reached || !date)
        return "Reached. Date and time weren’t recorded.";
    const crossed = validInstant(reached.reachedAt);
    if (crossed) {
        const time = new Intl.DateTimeFormat(locale, {
            timeStyle: "short",
            timeZone: reached.timezone,
        }).format(crossed);
        return `Reached ${date} at ${time}`;
    }
    return `Reached ${date}. Time wasn’t recorded.`;
}
//# sourceMappingURL=reached-date.js.map